<script>
import ChannelStore from './../stores/channel';
import CompanyStore from './../stores/company';
import TermsModal from './../components/modals/policies/TermsModal';
import IyzicoModal from './../components/modals/policies/IyzicoModal';
import PrivacyGlobalModal from '@/components/modals/policies/PrivacyGlobalModal';
import LanguageSelect from './../components/LanguageSelect.vue';
import PasswordInfo from './../components/PasswordInfo.vue';
import InputField from './../components/InputField.vue';
import Mailcheck from 'mailcheck';
import EmailAutoComplete from '../components/EmailAutoComplete.vue';

export default {
  components: {
    PrivacyGlobalModal,
    TermsModal,
    IyzicoModal,
    LanguageSelect,
    PasswordInfo,
    InputField,
    EmailAutoComplete,
  },
  inject: ['openRedirectModal', 'redirectModalState'],
  beforeRouteEnter(to, from, next) {
    let ref = '';
    if (to.query.ref !== undefined) {
      ref = to.query.ref;
    } else if (from.query.ref !== undefined) {
      ref = from.query.ref;
    }
    if (ref !== '') {
      $cookies.set('affiliate_ref', ref, '1d');
    }
    next();
  },
  created() {
    this.affiliate_ref = $cookies.isKey('affiliate_ref') ? $cookies.get('affiliate_ref') : null;

    const filteredCountries = ['WT'];
    if (!this.isWebsiteMukellef) {
      filteredCountries.push('TR');
    }
    if (this.$i18n.locale === 'en') {
      this.siteName = 'Workhy';
    }

    this.createTestFunctions();
    if (!this.affiliate_ref) {
      if (this.$route.query.partner) {
        this.partner = this.$route.query.partner;
        this.userComeWithLink = true;
      }
    } else {
      this.partner = 'affiliate';
      this.userComeWithLink = false;
    }

    CompanyStore.dispatch('getNations').then((s) => {
      let selectableCountries = s.data;
      selectableCountries = selectableCountries.filter(
        (country) => country.is_active && !filteredCountries.includes(country.name) && country.domain !== 'connect'
      );

      selectableCountries.push({
        id: 0,
        currency: 'OTHER',
        multi_lang: { en: { name: 'Other Countries' }, pt: { name: 'Outros Países' } },
        country_name: 'Diğer Ülkeler',
        is_active: 1,
      });

      this.selectableCountries = selectableCountries;
    });

    ChannelStore.dispatch('all').then((response) => {
      this.channels = response.data.data;

      if (this.partner) {
        this.channel = this.channels.find((channel) => channel.slug.toLowerCase() === this.partner.toLowerCase());
      }
    });
  },
  data() {
    return {
      name: this.$route.query.name,
      surname: null,
      password: null,
      password_confirmation: null,
      email: this.$route.query.email,
      partner: null,
      channels: [],
      channel: undefined,
      verified: false,
      passwordsInfoText: '',
      country: null,
      selectableCountries: [],
      isProduction: process.env.CF_PAGES_BRANCH.toLowerCase() === 'production',
      siteName: 'Mükellef',
      mobileNumberIsValid: false,
      mobile: null,
      affiliate_ref: '',
      defaultChannel: 'unknown',
      userComeWithLink: false,
      showPassword: false,
      emailDomains: [
        'gmail.com',
        'googlemail.com',
        'comcast.net',
        'yahoo.com',
        'hotmail.com',
        'aol.com',
        'msn.com',
        'live.com',
        'icloud.com',
        'zoho.com',
        'gmx.com',
        'protonmail.com',
      ],
      suggestedEmail: '',
    };
  },
  computed: {
    userIpLocale() {
      if (this.$store.state.userIpLocale) {
        return this.$store.state.userIpLocale;
      }
      return this.isWebsiteMukellef ? 'tr' : 'us';
    },
    selectedChannelId() {
      return this.channel && this.channel.id;
    },
  },
  rules: {
    channel: [(v) => !!v || 'Item is required'],
  },
  watch: {
    '$store.state.userIpLocale': {
      handler(newVal, oldVal) {},
      deep: true,
      immediate: true,
    },

    country: function (value) {
      if (value.id === 0) {
        const query = {};

        if (this.name) query.name = this.name;
        if (this.surname) query.surname = this.surname;
        if (this.email) query.email = this.email;

        if (this.isWebsiteMukellef) {
          this.openRedirectModal(value, `connect?lang=tr&${new URLSearchParams(query).toString()}`);
        } else {
          this.$router.push({
            path: '/connect',
            query: query,
          });
        }
      }
    },
    redirectModalState: function (val) {
      if (!val) {
        this.country = null;
      }
    },
  },
  methods: {
    mobilePhoneValidate(event) {
      this.mobileNumberIsValid = event.valid;
    },
    slug(text) {
      return text
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-');
    },
    register() {
      if (!this.$refs.passwordInfo.isPassed) {
        this.$toasted.error(this.$t('Şifre Mesajları.Parolanızı Kontrol Edin'));
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          let form = $('form#wrapped');

          form.validate();

          if (form.valid()) {
            let mobile = null;

            if (this.mobile) {
              if (!this.mobileNumberIsValid) {
                window.Vue.$toasted.error(this.$t('AlertMessages.Lütfen geçerli bir telefon numarası girin'));
                return;
              } else {
                mobile = '+' + this.mobile.replace(/[^0-9.]/g, '');
              }
            }

            this.startWaiting();

            const data = {
              name: this.name,
              surname: this.surname,
              password: this.password,
              nation_id: this.country.id,
              password_confirmation: this.password_confirmation,
              email: this.email,
              channel_id: this.selectedChannelId ? this.selectedChannelId : undefined,
              lang: this.$i18n.locale,
              mobile: mobile,
              ref: this.affiliate_ref,
              has_partner_link: this.userComeWithLink,
            };

            $axios.post('register', data).then(
              (s) => {
                if ($cookies.isKey('affiliate_ref')) {
                  $cookies.remove('affiliate_ref');
                }

                this.startWaiting();

                this.$toasted.show(this.$t('AlertMessages.Hesabınız oluşturuldu, giriş yapılıyor'));

                $axios
                  .post('oauth/token', {
                    username: this.email,
                    password: this.password,
                    grant_type: 'password',
                    client_id: process.env.VUE_APP_API_CLIENT_ID,
                    client_secret: process.env.VUE_APP_API_CLIENT_SECRET,
                    scope: '*',
                  })
                  .then(
                    (s) => {
                      const token = s.data;
                      this.setAccessToken(token);
                      // Get user info
                      this.$store.dispatch('getSelf').then(() => {
                        let mainDashboardUrl;

                        if (this.isWebsiteMukellef) {
                          mainDashboardUrl = process.env.VUE_APP_MUKELLEF_DASHBOARD_URL;
                        } else {
                          mainDashboardUrl = process.env.VUE_APP_WORKHY_DASHBOARD_URL;
                        }

                        const decodedToken = btoa(JSON.stringify(this.getToken()));

                        window.location = mainDashboardUrl + '?t=' + decodedToken;
                      });
                    },
                    (e) => {
                      this.$toasted.error(this.$t('AlertMessages.Yanlış e-posta adresi veya şifre'));
                      this.endWaiting();
                    }
                  );
              },
              (e) => {}
            );
          }
        }
      });
    },
    createTestFunctions() {
      this.selectCountry();
      this.selectChannel();
    },

    checkEmail() {
      Mailcheck.run({
        email: this.email,
        suggested: (suggestion) => {
          if (this.emailDomains.includes(suggestion.domain)) {
            this.suggestedEmail = suggestion.full;
          } else {
            this.suggestedEmail = '';
          }
        },
        empty: () => {
          this.suggestedEmail = '';
        },
      });
    },
    useSuggestedEmail() {
      this.email = this.suggestedEmail;
      this.suggestedEmail = '';
    },
  },
};
</script>
<template>
  <div>
    <div class="container-fluid full-height">
      <div class="row row-height">
        <hello :partner="partner" :channel="channel" show-campaign />
        <div id="start" class="col-lg-6">
          <div id="wizard_container">
            <div class="mb-2">
              <LanguageSelect />
            </div>
            <!-- /top-wizard -->
            <form id="wrapped" @submit.prevent="register">
              <input id="website" name="website" type="text" value />
              <!-- Leave for security protection, read docs for details -->
              <div id="middle-wizard">
                <div class="submit step">
                  <h3 class="main_question">
                    {{ $t('Şirketinizi Kurun, Yönetin ve Büyütün') }}
                  </h3>
                  <div class="row" lang="tr">
                    <div class="col-6">
                      <InputField
                        v-model="name"
                        name="name"
                        :placeholder="$t('Ad')"
                        v-validate="'required'"
                        :error="errors.first('name')"
                        :validateFields="fields['name']"
                      />
                    </div>
                    <div class="col-6">
                      <InputField
                        v-model="surname"
                        name="surname"
                        :placeholder="$t('Soyad')"
                        v-validate="'required'"
                        :error="errors.first('surname')"
                        :validateFields="fields['surname']"
                      />
                    </div>
                  </div>
                  <!-- /row -->

                  <EmailAutoComplete
                    ref="EmailAutoComplete"
                    :onCompletion="(val) => (email = val)"
                    :domains="emailDomains"
                  >
                    <InputField
                      v-model.trim="email"
                      name="email"
                      :placeholder="$t('E-posta')"
                      v-validate="'required|email'"
                      :error="errors.first('email')"
                      :validateFields="fields['email']"
                      @keydown="$refs.EmailAutoComplete.check($event)"
                      @blur="checkEmail"
                      :autocomplete="false"
                    >
                      <template #inputNoteText>
                        <div v-if="suggestedEmail" class="mt-1">
                          {{ $t('Did you mean') }}
                          <a href="#" @click.prevent="useSuggestedEmail">{{ suggestedEmail }}</a>
                        </div>
                      </template>
                    </InputField>
                  </EmailAutoComplete>

                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <input
                          v-model="password"
                          class="form-control password-input"
                          name="password1"
                          :placeholder="$t('Şifre')"
                          :class="{ 'is-invalid': errors.first('password') }"
                          :type="showPassword ? 'text' : 'password'"
                          v-validate="'required'"
                          ref="password"
                        />
                        <svg
                          v-if="!showPassword"
                          @click="showPassword = !showPassword"
                          class="password-eye"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#9d9d9d"
                            d="M4.707 3.293a1 1 0 0 0-1.414 1.414l2.424 2.424c-1.43 1.076-2.678 2.554-3.611 4.422a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19c1.555 0 3.1-.355 4.53-1.055l2.763 2.762a1 1 0 0 0 1.414-1.414zm10.307 13.135c-.98.383-2 .572-3.014.572c-2.969 0-6.002-1.62-7.87-5c.817-1.479 1.858-2.62 3.018-3.437l2.144 2.144a3 3 0 0 0 4.001 4.001zm3.538-2.532c.483-.556.926-1.187 1.318-1.896c-1.868-3.38-4.9-5-7.87-5q-.168 0-.336.007L9.879 5.223A10.2 10.2 0 0 1 12 5c3.903 0 7.736 2.236 9.894 6.553a1 1 0 0 1 0 .894a13 13 0 0 1-1.925 2.865z"
                          />
                        </svg>
                        <svg
                          v-if="showPassword"
                          @click="showPassword = !showPassword"
                          class="password-eye"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <g fill="#9d9d9d">
                            <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0" />
                            <path
                              d="M21.894 11.553C19.736 7.236 15.904 5 12 5s-7.736 2.236-9.894 6.553a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19s7.736-2.236 9.894-6.553a1 1 0 0 0 0-.894M12 17c-2.969 0-6.002-1.62-7.87-5C5.998 8.62 9.03 7 12 7s6.002 1.62 7.87 5c-1.868 3.38-4.901 5-7.87 5"
                            />
                          </g>
                        </svg>
                        <span v-show="errors.first('password')" class="invalid-feedback">{{
                          errors.first('password')
                        }}</span>
                      </div>
                    </div>
                    <div class="col-6">
                      <InputField
                        v-model="password_confirmation"
                        name="password2"
                        :placeholder="$t('Şifre Tekrar')"
                        v-validate="'required|confirmed:password'"
                        :error="errors.first('password2')"
                        :type="showPassword ? 'text' : 'password'"
                        :validateFields="fields['password2']"
                      />
                    </div>
                  </div>

                  <PasswordInfo
                    :password="password"
                    :password_confirmation="password_confirmation"
                    :name="name"
                    :surname="surname"
                    ref="passwordInfo"
                  />

                  <div class="row mobile-abtest">
                    <div class="col-md-12">
                      <div class="form-group">
                        <vue-tel-input
                          id="phone-mask"
                          @validate="mobilePhoneValidate"
                          :defaultCountry="userIpLocale"
                          :autoDefaultCountry="false"
                          :key="userIpLocale"
                          v-model="mobile"
                          class="form-control"
                          :class="mobile && !this.mobileNumberIsValid ? 'is-invalid' : 'is-valid'"
                          :input-options="{ placeholder: $t('Cep Telefonu Numarası') }"
                          validCharactersOnly
                        ></vue-tel-input>
                        <span v-show="mobile && !this.mobileNumberIsValid" class="invalid-feedback">{{
                          $t('AlertMessages.Girdiğiniz telefon numarası geçerli değil')
                        }}</span>
                        <error-box field="mobile" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <div class="clearfix">
                          <v-select
                            v-model="country"
                            :options="selectableCountries"
                            :searchable="false"
                            class="wide"
                            :class="{ 'is-invalid': errors.first('select_country') }"
                            label="country_name"
                            name="select_country"
                            v-validate="'required'"
                            :placeholder="$t('Hizmet almak istediğiniz ülkeyi seçin')"
                            required
                          >
                            <template slot="selected-option" slot-scope="option">
                              <img class="mr-2 select-icon-width" :src="'/img/icons/' + option.name + '.svg'" alt="" />
                              {{ getMultiLangName(option, option.country_name) }}
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-flex align-items-center">
                                <img
                                  class="mr-2 select-icon-width"
                                  :src="'/img/icons/' + option.name + '.svg'"
                                  alt=""
                                />
                                {{ getMultiLangName(option, option.country_name) }}
                              </div>
                            </template>
                            <span slot="no-options">{{ $t('Üzgünüz belirtmiş olduğunuz seçenek bulunamadı') }}</span>
                          </v-select>
                          <span v-show="errors.first('select_country')" class="show-invalid invalid-feedback">{{
                            errors.first('select_country')
                          }}</span>
                          <error-box field="select_country" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="country" class="form-group terms">
                    <div class="agreements">
                      <div class="terms-of-use mb-3">
                        <label for="agreement-terms-of-use" class="container_check mb-1 d-flex align-items-center">
                          <i18n path="home.terms_of_use.text" tag="span">
                            <template v-slot:terms_text>
                              <a data-target="#terms-modal" data-toggle="modal" href="#">{{
                                $t('home.terms_of_use.terms_text', { website: websiteName })
                              }}</a>
                            </template>
                            <template v-slot:privacy_text>
                              <a data-target="#privacy-global-modal" data-toggle="modal" href="#">{{
                                $t('home.terms_of_use.privacy_text')
                              }}</a>
                            </template>
                          </i18n>
                          <input
                            type="checkbox"
                            id="agreement-terms-of-use"
                            name="agreement-terms-of-use"
                            v-validate="'required'"
                          />
                          <span class="checkmark"></span>
                        </label>
                        <span v-show="errors.first('agreement-terms-of-use')" class="show-invalid invalid-feedback">{{
                          errors.first('agreement-terms-of-use')
                        }}</span>
                        <error-box field="agreement-terms-of-use" />
                      </div>
                      <div class="personal-data">
                        <label for="agreement-personal-data" class="container_check mb-1 d-flex align-items-center">
                          <i18n path="home.personal_data.text" tag="span">
                            <template v-slot:privacy_text>
                              <a data-target="#privacy-global-modal" data-toggle="modal" href="#">{{
                                $t('home.personal_data.privacy_text')
                              }}</a>
                            </template>
                          </i18n>
                          <input
                            type="checkbox"
                            id="agreement-personal-data"
                            name="agreement-personal-data"
                            v-validate="'required'"
                          />
                          <span class="checkmark"></span>
                        </label>
                        <span v-show="errors.first('agreement-personal-data')" class="show-invalid invalid-feedback">{{
                          errors.first('agreement-personal-data')
                        }}</span>
                        <error-box field="agreement-personal-data" />
                      </div>
                    </div>
                  </div>
                  <!-- /row -->
                </div>

                <button :disabled="isWaiting" class="mt-3 submit" name="process" type="submit">
                  {{ $t('Kayıt Ol').toUpperCase() }}
                </button>
              </div>
              <!-- /middle-wizard -->
              <div id="bottom-wizard"></div>
              <!-- /row -->
              <!-- /bottom-wizard -->
              <div class="row mb-2 mt-3">
                <div class="col-12">
                  <strong>
                    {{ $t('Hesabınız mı var?') }}
                    <router-link :to="pathFindWithLanguage('/login')">{{ $t('Giriş Yap') }}</router-link>
                  </strong>
                </div>
              </div>
            </form>
          </div>
          <!-- /Wizard container -->
        </div>
        <!-- /content-right-->
      </div>
      <!-- /row-->
    </div>
    <!-- /container-fluid -->
    <div class="cd-overlay-nav">
      <span></span>
    </div>
    <!-- /cd-overlay-nav -->
    <div class="cd-overlay-content">
      <span></span>
    </div>
    <!-- /cd-overlay-content -->

    <TermsModal :countryCode="country ? country.name : ''" />
    <PrivacyGlobalModal :is-customer="false" />
    <IyzicoModal />
  </div>
</template>

<style>
.select-icon-width {
  width: 1.7rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.password-input {
  position: relative;
}

.password-eye {
  position: absolute;
  right: 0.5rem;
  transform: translateY(-50%);
  top: 50%;
  cursor: pointer;
  z-index: 1;
  fill: red;
}
</style>
